import update from "immutability-helper";
import { LOAD_DOCUMENTS_DEADLINES } from "./actions";
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';

const DEFAULT_STATE = {
  list: [],
  isLoading: true,
};

const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CACHE_ACTIONS.documentsDeadlines: {
      return update(state, {
        $set: {
          list: action.payload,
          isLoading: false
        }
      });
    }

    case LOAD_DOCUMENTS_DEADLINES.SUCCESS: {
      return update(state, {
        $set: {
          list: action.payload.data.tasks,
          isLoading: false,
        },
      });
    }

    default:
      return state;
  }
};

export default reducer;
